export default {
  retailNetworkName: "",
  points: [],
  // image: null,
};
